/* Aditional Services List
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */

import React from 'react'
import styled from 'styled-components'
import { MEDIA_BASE_URL } from '../../config'

const AditionalServicesV2 = ({ list, style }) => (
  <Row style={style}>
    <Cell>Condições adicionais</Cell>
    <ListCell>
      {list &&
        list.map((item, index) => (
          <span key={index}>
            <img src={`${MEDIA_BASE_URL}${item.icon}`} alt={item.name} />
            <p>{item.name}</p>
          </span>
        ))}
      {!list.length && <p>-</p>}
    </ListCell>
  </Row>
)

export default AditionalServicesV2

const Row = styled.tr`
  display: flex;
  padding: 10px 16px;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  border-bottom: 1px solid #ececec;
`

const Cell = styled.td`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  gap: 4px;

  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

const ListCell = styled.td`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;

  > span {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-self: stretch;
    gap: 4px;
  }

  p {
    color: #1d1e22;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/AditionalServicesV2/index.js